import { o_util, win } from "../common/namespaces";
import type { GlobalUtils } from "../exports";
import type { OttoNexus } from "../lib/nexus";

export type { OnexRaw } from "../lib/onex/index.js";

/**
 *
 *
 *
 *
 */
export type OnexSync = GlobalUtils["onex"];

/**
 *
 *
 *
 *
 *
 */
export const onexSync: OnexSync = o_util.onex;

/**
 *
 *
 *
 *
 */
export type OnexAsync = OttoNexus["onex"];

/**
 *
 *
 */
export const onexAsync: OnexAsync = win.otto.onex;
